module.exports = __webpack_public_path__ + "img/platicmenories.4bd2e702.jpg";